import React from "react";

const vaishnavi_shambharkar = () => {
  return (
    <div>
      <h1>Vaishnavi Shambharkar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        For the interviews shortlisting aptitude test was taken, from the
        college campus. At the end of which twenty two people were selected.
        <br />
        At the end of two technical rounds nine people were selected for the HR
        round. And finally at the end seven people were selected for the
        internship.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        First there was an aptitude round, the next day interviews were
        scheduled. We had 3 rounds on that day. Two technical rounds and one HR
        round.{" "}
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        MCQ’s and two coding questions. MCQ’s were on Operating Systems
        (preemption, page faults etc ), DBMS, Networks (subnetting) and two
        coding questions.{" "}
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        Around twenty two students were shortlisted after the Aptitude Round.{" "}
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist for the interviews came at around 11pm and interviews were
        scheduled for the next day. As I had very less time, I focused on how I
        was going to explain my projects and went through my DBMS notes. The
        next day, I got up early and revised OOP concepts.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        The first technical round - focused on projects, DBMS and DSA
        <br />
        In the second technical round - I was asked about one project to explain
        in detail and also to draw the architectural diagram. I was also asked
        about how I addressed security concerns in the project too.
        <br />
        In the HR round - I was asked about my previous internship, my role as a
        coordinator in PSF Web and Tech and also my role as a Technical Head in
        CSI. I was asked about my three best and worst qualities.{" "}
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The questions were focused mainly on DSA, DBMS and Projects.
        <br />
        I was given two dsa questions - in the first technical round and one dsa
        question in the second technical round.
        <br />
        The dsa questions were easy to medium in level of complexity (doing
        leetcode really helped).
        <br />
        And a few questions on DBMS in the first technical round - about
        partitioning and sharding, differences between DML and DQL, I was also
        asked to write a query to find the second maximum salary from the
        employees table.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        OOPs and java - Kunal Kushwaha
        <br />
        Networks - Kunal Kushwaha
        <br />
        DBMS - love babbar playlist ( I completed watching the playlist in about
        two months )<br />
        DSA - striver’s youtube channel and love babbar dsa playlist (DW you
        don't have to do the whole playlist - I just referred to the playlist
        for the BSTs and Graphs and DP).{" "}
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practise as much as you can on leetcode. Prioritise quality over
        quantity. And while you code try to use vi or vim as this would increase
        your speed over time and you won’t have to depend on autocomplete.{" "}
      </p>

      <p>
        Also for the interviews make sure to think out loud. Whatever you think
        - try to explain it to the interviewer and write down your approach on
        the paper. Even if you are not able to write the code (in an interview)
        at least try to explain your approach really well.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In all three rounds I was asked about my projects - I tried to explain
        the projects in the following manner:
        <br />
        Problem statement -> How did I get the idea about the project -> my
        approach to solving the problem.
        <br />
        In the HR round - I was asked about my extra curricular activities and
        previous internship.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        For aptitude practise some MCQ’s on Networks, OS, DBMS and OOPs from
        India-Bix platform. I think that really helped me ace the MCQ questions
        in the aptitude round.
        <br />
        For the technical rounds - make sure you explain your projects really
        well, and explain the coding question approach on paper in the following
        manner :<br />
        Intuition -> Brute Force -> Better (if it exists) -> Optimal.
        <br />
        Make sure you showcase how you are really creative when it comes to
        problem solving and a fast learner.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Focus on what you know, do interesting projects to add to your resume
        (something that solves some real world problem or has a practical
        application)
        <br />
        Develop your speaking skills, think out loud in interviews.
        <br />
        Don’t try to cram everything when you are studying core subjects like
        DBMS, OOPs or Networks - try to be thorough with the basics and go into
        a little depth even if it takes time, I think it’s better to know
        something in detail rather than knowing everything on the surface level.
        <br />
        You can do this - list down the topics most important for the interviews
        and do them in detail and side by side keep solving leetcode.{" "}
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9356916825
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:shambharkarvv23.comp@coeptech.ac.in">
          shambharkarvv23.comp@coeptech.ac.in
        </a>
      </p>

      <hr />
    </div>
  );
};

export default vaishnavi_shambharkar;
